module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-expand-height', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ["form__errors", "errors"]
  }, [_c('li', {
    staticClass: "errors__item small"
  }, [_vm._v(_vm._s(_vm.serverError || _vm.error))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c4d57ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/form/Errors.vue
// module id = 99
// module chunks = 3